export default {"src":"/_next/static/media/rebrabded-checkmark-icon.56ba95ac.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};